import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchFlightHome as fetchFlightHomeApi,
  fetchFlightOffers as fetchFlightOffersApi,
  fetchFlightRoutes as fetchFlightRoutesApi,
  searchFlights as searchFlightsApi,
} from "@/services/api/flights";

const initialState = {
  home: null,
  routes: [],
  offers: [],
  searchResults: [],
  loading: false,
  error: null,
};

export const fetchFlightHome = createAsyncThunk(
  "flight/fetchHome",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchFlightHomeApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load flight home");
    }
  }
);

export const fetchSearchFlights = createAsyncThunk(
  "flight/search",
  async (payload, { rejectWithValue }) => {
    try {
      return await searchFlightsApi(payload);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to search flights");
    }
  }
);

export const fetchFlightRoutes = createAsyncThunk(
  "flight/fetchRoutes",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchFlightRoutesApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load flight routes");
    }
  }
);

export const fetchFlightOffers = createAsyncThunk(
  "flight/fetchOffers",
  async (params, { rejectWithValue }) => {
    try {
      return await fetchFlightOffersApi(params);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load flight offers");
    }
  }
);

const flightSlice = createSlice({
  name: "flight",
  initialState,
  reducers: {
    clearFlightError(state) {
      state.error = null;
    },
    resetFlightState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlightHome.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFlightHome.fulfilled, (state, action) => {
        state.loading = false;
        state.home = action.payload;
      })
      .addCase(fetchFlightHome.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSearchFlights.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSearchFlights.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload;
      })
      .addCase(fetchSearchFlights.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchFlightRoutes.fulfilled, (state, action) => {
        state.routes = action.payload;
      })
      .addCase(fetchFlightOffers.fulfilled, (state, action) => {
        state.offers = action.payload;
      });
  },
});

export const { clearFlightError, resetFlightState } = flightSlice.actions;
export default flightSlice.reducer;
